export default "__VITE_ASSET__BFux_Niq__"